import type {Spring} from "framer-motion";

export const springMotionTransition: Spring = {
    type: "spring",
    stiffness: 300,
    damping: 30
};
import type {Spring} from "framer-motion";

export const springMotionTransition: Spring = {
    type: "spring",
    stiffness: 300,
    damping: 30
};
